<template>
  <div class="gallery section">
    <h2>{{ $t('gallery.galeria') }} </h2>
    <div class="separator" />
    <slider :type="'gallery'"
            :elements="gallery" />
    <full-screen v-if="openFullScreen"
                 class="full-screen-gallery">
      <slider :type="'full-screen-gallery'"
              :elements="gallery"
              :element-init-id="index"
              class="full-screen-slider" />
    </full-screen>
  </div>
</template>
<style lang="scss">
.full-screen-slider {
  width: 80%;
  margin: auto;
  top: 10%;
  height: 80%;
}
</style>

<script>
import Slider from '@/components/slider/Slider.vue'
import FullScreen from '@/components/full-screen/FullScreen.vue'

export default {
  components: {
    Slider,
    FullScreen
  },
  props: {
    gallery: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    openFullScreen: false,
    index: 0
  }),
  created() {
    this.$root.$on('openFullScreenGallery', data => {
      this.index = data
      this.openFullScreen = true
    })
    this.$root.$on('closeFullScreen', () => {
      this.openFullScreen = false
    })
  }
}
</script>
